import LegalPage from '@/pages/legal/legal-page'

export default function Privacy() {
  return <LegalPage documentKey="privacy" path="/privacy" />
}
